
import { EnumI18nActions } from './i18n_actions';
import update from 'immutability-helper';
const initialState = {
    listI18n: [],
    i18n: {
        listApLang: [],
        code: null,
        searchPar:''
    },
    apLangConst: []

}

const localizzazione = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }
    switch (action.type) {
        case EnumI18nActions.LOCAL_INITIALIZED:
            return initialState
        case EnumI18nActions.LOCAL_I18N_LIST:
            return Object.assign({}, state, { listI18n: action.dati, })
        case EnumI18nActions.LOCAL_I18N_DETAILS:
            return Object.assign({}, state, { listI18n: action.dati, })
        case EnumI18nActions.LOCAL_I18N:
            return update(state, {
                i18n: { $merge: action.dato }
            });
        case EnumI18nActions.LOCAL_UPDATE_I18N:
            return update(state, action.dato
            );
        case EnumI18nActions.LOCAL_APP_LANG:
            return Object.assign({}, state, { apLangConst: action.dati, })
        //     return update(state, { i18n: action.i18n });
        // // Object.assign({}, state, { i18n: action.dato, })
        // case EnumI18nActions.IMPOSTAZIONI_HANDLE_CHANGE_CODICE:
        //     return Object.assign({}, state, { i18n: action.dati, })
        case EnumI18nActions.LOCAL_APP_LANG_EXPORT:
            return Object.assign({}, state, { test: action.dati, })
        default:
            return state;
    }
}

export default localizzazione;